export default {
  PriceBook: require('../assets/PriceBook.jpg'),
  GrillMaster: require('../assets/GrillMaster.jpg'),
  NutritionCoach: require('../assets/NutritionCoach.jpg'),
  Stampa: require('../assets/Stampa.jpg'),
  Veriscan: require('../assets/VeriscanW.jpg'),
  FreelanceNowA: require('../assets/FreelanceNow.jpg'),
  PickMeA: require('../assets/PickMe.jpg'),
  QRTagitA: require('../assets/QRTagit.jpg'),
  VeriscanA: require('../assets/Veriscan.jpg'),
};
